import { Component, Injectable, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { bounceAnimation } from 'angular-animations';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DocumentoService } from 'src/app/services/documento.service';
import { GLOBAL } from 'src/app/services/global';
declare const swal: any;
interface AppState {
  form: Form;
}
@Injectable()

@Component({
  selector: 'app-documentos-insp',
  templateUrl: './documentos-insp.component.html',
  styleUrls: ['./documentos-insp.component.css'],
  providers: [DocumentoService],
  animations: [
    bounceAnimation(),
  ]
})
export class DocumentosInspComponent implements OnInit {

  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('modalArchivos') modalArchivos: TemplateRef<any>;
  @ViewChild('modalAdjuntos') modalAdjuntos: TemplateRef<any>;
  @ViewChild('confirmaSubida') confirmaSubida: TemplateRef<any>;
  public acotado = GLOBAL.acotado;
  docRepetido: boolean = false;
  fileRepetido: boolean = false;
  quarterFormGroup: FormGroup;
  public yasubieron = false;
  public files = [];
  nombreDeDocumento;
  newFiles: FileList;
  newFile: File;
  public rows = []
  nombreDeArchivo;
  public actualSizeFiles = 0
  public documentoNombre = ''
  public animate = false;
  public maxSizeFiles = 75000000
  public adjuntos = []
  zip;
  nombreArchivo;
  public nombreMuni = GLOBAL.nombreMuni;
  form;
  validador: boolean = false;




  constructor(private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private _documentosServices: DocumentoService,
    private toastr: ToastrService,



  ) {
    this.quarterFormGroup = this._formBuilder.group({


    })
  }

  ngOnInit(): void {
    this.validador = false;
    this.dialog.closeAll();
    localStorage.setItem("ZipURL", JSON.stringify(null));
    localStorage.setItem("adjuntos", JSON.stringify(null));


  }

  ngDoCheck() {
    
  }

  crearSolicitudInspeccion() { }




  adjuntoSave(fileName = null) {


    //console.log("adjuntoSave this.files", this.files);
    //console.log("adjuntoSave this.nombreDeDocumento.trim()", this.nombreDeDocumento.trim());
    var subidos = { "archivosSubidos": false };
    localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
    this.files.push({ name: this.nombreDeDocumento.trim(), doc: this.newFile })
    // this.files.forEach(element => {
    //     this.docNames.push(element.name.trim());
    //     this.fileNames.push(element.doc.name.trim());
    // });

    let peso = (this.newFiles.item(0).size / 1000000) + ' MB'
    this.rows = (this.rows == null) ? [] : this.rows;


    //console.log(this.nombreDeDocumento, this.nombreDeArchivo, peso, 'VALORES');
    //console.log('rows', this.rows);
    if (this.rows.length > 2) {
      //console.log('ESTAS PASANDO MAS DE 2');
      this.toastr.warning(`Se aceptan solamente 2 archivos como maximo  `);

    }
    if (this.rows.length < 2) {
      //console.log('ESTAS PASANDO LO PERMITIDO');

      this.rows = this.rows.concat({
        name: this.nombreDeDocumento.trim(),
        archivo: this.nombreDeArchivo.trim(),
        peso: peso,
        estado: "Pendiente"
      })
      this.validador = true

      //console.log('rows', this.rows);
      localStorage.setItem("adjuntos", JSON.stringify(this.rows));
      this.actualSizeFiles = this.actualSizeFiles + this.newFiles.item(0).size
      this.checksSize(this.files.length - 1)

      this.documentoNombre = ''
      this.cerrarModal();
      //animar
      this.animate = true;
      setTimeout(() => {
        this.animate = !this.animate;
      }, 1);
    }

  }
  cerrarModal() {
    this.nombreArchivo = ''
    this.dialog.closeAll();

  }
  checksSize(index = null) {
    //console.log("this.actualSizeFiles > this.maxSizeFiles", this.actualSizeFiles, this.maxSizeFiles);

    if (this.actualSizeFiles > this.maxSizeFiles) {
      this.deleteFile(index)
      this.alertMaxsize()
      this.cerrarModal()
    }
  }

  validarSubida() {
    //console.log('validar subida');
    this.fileRepetido = false;
    this.docRepetido = false;
    this.nombreDeDocumento = this.documentoNombre; //documentoNombre = nombre ingresado en input

    let regexp = new RegExp(/^\s+$/);
    if (this.documentoNombre.match(regexp)) {
      this.documentoNombre = this.nombreArchivo;
      this.nombreDeDocumento = this.documentoNombre;
      //console.log('espacio(s) en blanco o vacio, renombrado: ', this.documentoNombre)
      this.toastr.warning(`El Nombre del Documento estaba en blanco, se renombró: ${this.nombreDeDocumento} `);
    }

    this.files.forEach(element => {
      if (element.name == this.nombreDeDocumento) {
        this.docRepetido = true;
      }
    });
    let filenameCounter = 0;
    this.nombreDeArchivo = this.nombreArchivo;
    this.files.forEach(element => {
      // //console.log('element', element)
      // //console.log('element.doc.archivo', element.doc.name)
      if (element.doc.name == this.nombreArchivo) {
        this.fileRepetido = true;
      }
    });
    //console.log("this.fileRepetido", this.fileRepetido)
    //console.log("this.docRepetido", this.docRepetido)
    if (!this.fileRepetido && !this.docRepetido) {
      this.adjuntoSave();
    }
    else {
      if (this.fileRepetido) {
        swal({
          icon: 'error',
          title: 'Archivo erroneo',
          text: '<p>Usted ya adjunto un archivo con el mismo nombre , o esta intentando ingresar mas de 2 archivos</p>',
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false
        }).then(() => {
          this.cerrarModal();
        })
      }
      else if (this.docRepetido) {
        swal({
          icon: 'error',
          title: 'Nombre de documento duplicado',
          text: '<p>Usted ya adjunto un documento con el mismo nombre</p>',
          showConfirmButton: true,
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false
        }).then(() => {
          this.cerrarModal();
        })
      }
    }
  }
  handleFileInput(files: FileList) {
    //console.log('before this.files ', this.files)
    //this.newFile: File //nuevo file
    this.newFile = files.item(0)
    this.newFiles = files;
    let actualRow = localStorage.getItem("adjuntos");
    //console.log('actualRow (  localStorage.getItem("adjuntos")  )', actualRow);
    this.rows = JSON.parse(actualRow);
    //this.nombreDeArchivo = "";//nombre despues agregar (1||+)
    //this.nombreDeDocumento = "";//nombre despues agregar (1||+)
    this.nombreArchivo = files.item(0).name
    //console.log("before nombre de archivo", this.nombreArchivo);
  }


  openAdjuntosModal() {
    this.dialog.open(this.modalAdjuntos, { disableClose: true });
  }

  deleteFile(index = null) {
    if (index != null) {
      //recalcular size
      let fil: File
      fil = this.files[index].doc
      this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
      //console.log("this.actualSizeFiles - fil.size", this.actualSizeFiles, fil.size);

      //Remove file
      //console.log("files", this.files, "index", index)
      this.files.splice(index, 1)
      let actualRow = localStorage.getItem("adjuntos");
      this.rows = JSON.parse(actualRow);
      this.rows.splice(index, 1)
      if (this.rows.length === 0) {
        this.validador = false;
      }
      if (this.rows.length != 0) {
        this.validador = true;

      }
      localStorage.setItem("adjuntos", JSON.stringify(this.rows));
    } else {
      //recalcular size
      let fil: File
      fil = this.files[this.files.length - 1].doc
      this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
      //Remove file
      this.files.splice(this.files.length - 1, 1)
      let actualRow = localStorage.getItem("adjuntos");
      this.rows = JSON.parse(actualRow);
      this.rows.splice(this.rows.length - 1, 1)
      localStorage.setItem("adjuntos", JSON.stringify(this.rows));
    }
  }


  alertMaxsize() {
    swal({
      icon: 'error',
      title: 'Supero el máximo de MB para tus adjuntos',
      text: '<p>Usted cuenta con un máximo de <strong>75 MB</strong> para utilizar</p>',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false
    })
  }

  confirmarSubida() {

    this.dialog.open(this.confirmaSubida, { disableClose: true });

  }

  uploadAllfiles() {
    //console.log('subir archivos');
    let formType = (this.form) ? this.form : 'Acotado';
    this.spinner.show();


    if (this.nombreMuni == 'Penaflor') {

      console.log("Enviar Archivos Penaflor");
      this._documentosServices.uploadFiles(this.files, formType).subscribe(
        response => {

          //console.log('uploadFiles response', response)
          //console.log('uploadFiles response', JSON.parse(response._body))
          this.spinner.hide();


          var subidos = { "archivosSubidos": true };



          this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
          this.adjuntos.forEach(element => {
            element.estado = "Subido"
          });
          localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos))
          let actualRow = localStorage.getItem("adjuntos");
          this.rows = JSON.parse(actualRow);
          //console.log('JSON.parse(localStorage.getItem("adjuntos"))', JSON.parse(localStorage.getItem("adjuntos")));


            console.log("response.code",response.code)

          localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
          let alert = { icon: 'success', text: '', title: '' }

          if (response.code == 99) {

            this.cerrarModal();
            console.log('ya subieron')
            this.yasubieron = true;
            this.validador = false;

            localStorage.setItem('ZipURL', response.url)
            alert.icon = 'success'
            alert.text = '<p>Se subieron los archivos correctamente<br><br></p>'
            alert.title = 'Archivos cargados'
            //localStorage.setItem('ZipURL', response.url)
          } else if (response.code == 98) {
            alert.icon = 'error'
            alert.text = '<p>No se adjuntaron documentos</p>'
            alert.title = 'Archivos no cargados'
          } else if (response.code == 97) {
            alert.icon = 'error'
            alert.text = '<p>No se adjuntaron documentos</p>'
            alert.title = 'Archivos no cargados'
          } else if (response.code == 96) {
            alert.icon = 'error'
            alert.text = '<p>Archivos no permitidos</p>'
            alert.title = 'Archivos no cargados'
          }
          else {
            alert.icon = 'error'
            alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>'
            alert.title = 'Archivos no cargados'
          }

          swal({
            icon: alert.icon,
            title: alert.title,
            text: alert.text,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );

        },
        error => {
          this.spinner.hide();
          console.log("un error", error);
          this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));

          var subidos = { "archivosSubidos": false };
          localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
          swal({
            icon: 'error',
            title: 'Error al subir documentación',
            text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );
        }
      )



    }
    else {
      //console.log('this.documentosService 587');
      console.log("documentosServices.uploadInspeccoinesDBX()")
      console.log("this.files",this.files)
      this._documentosServices.uploadInspeccionDBX(this.files, formType).subscribe(
        (response: any) => {
          this.spinner.hide();

          //console.log('587 empezo upload bnupdbxXX', response);

          this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));

          this.adjuntos.forEach(element => {
            element.estado = "Subido"
          });
          localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos))
          let actualRow = localStorage.getItem("adjuntos");
          this.rows = JSON.parse(actualRow);
          //console.log('676');

          //console.log('JSON.parse(localStorage.getItem("adjuntos"))', JSON.parse(localStorage.getItem("adjuntos")));
          //console.log('678');
          var subidos = { "archivosSubidos": true };
          localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
          //console.log('684');

          let alert = { icon: 'success', text: '', title: '' }
          console.log('601 response', response);
          console.log("response.code",response.code)
          console.log("response.url",response.url)
          if (response.code === 99 && response.url) {
            this.validador = false;
            //console.log('validador ',this.validador);

            this.cerrarModal();
            console.log('ya subieron')
            this.yasubieron = true;

            alert.icon = 'success'
            alert.text = '<p>Puedes revisar una vez más tus documentos, usa el siguiente link <br><br> <a mat-stroked-button href="' + response.url + '" style="text-decoration=none" target="_blank"><strong>Descarga tus documentos<strong></a><br><br><br></p>'
            alert.title = 'Archivos cargados'
            localStorage.setItem('ZipURL', response.url)
            this.zip = localStorage.getItem('ZipURL');
            //console.log('zipUrl ', this.zip);
            this.validador === false;
            
          } else if (response.code == 98) {
            alert.icon = 'error'
            alert.text = '<p>No se adjuntaron documentos</p>'
            alert.title = 'Archivos no cargados'
          } else if (response.code == 97) {
            alert.icon = 'error'
            alert.text = '<p>No se adjuntaron documentos</p>'
            alert.title = 'Archivos no cargados'
          } else if (response.code == 96) {
            alert.icon = 'error'
            alert.text = '<p>Archivos no permitidos</p>'
            alert.title = 'Archivos no cargados'
          }
          else {
            alert.icon = 'error'
            alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>'
            alert.title = 'Archivos no cargados'
          }

          swal({
            icon: alert.icon,
            title: alert.title,
            text: alert.text,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );

        },
        error => {
          this.spinner.hide();
          //console.log("un error", error);
          var subidos = { "archivosSubidos": false };
          localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
          swal({
            icon: 'error',
            title: 'Error al subir documentación',
            text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );
        }
      )

    }
  }






}
